(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['app/feature-config/FeatureConfigModel', 'services/financialFeatureConfigService', 'app/launcherApplicationInterface','app/applicationUtils'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var financialFeatureConfigService = require('./../urls').financialFeatureConfigService;
    module.exports = factory(require('./../feature-config/FeatureConfigModel'), financialFeatureConfigService, require('./../launcherApplicationInterface'), require('./../applicationUtils'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (FeatureConfigModel, financialFeatureConfigService, launcherAppInterface, applicationUtils) {
  'use strict';

  /**
   * Model for financial configuration information. Uses the FinancialFeatureConfigService and corresponds to a FinancialFeatureConfig
   *
   * @class FinancialFeatureConfigModel
   * @extends FeatureConfigModel
   * @deprecated new fields should not be getting added to this class. Instead use billingConfigModel(financial microservice)
   * @constructor
   */
  return new (FeatureConfigModel.extend({
    urlRoot: financialFeatureConfigService,

    /**
     * @method isEstimatedCostEnabled
     * @param configLevel {String} to check whether this level is enabled - one of
     *        FeatureConfigModel.CONFIG_LEVEL.MINIMAL, FeatureConfigModel.CONFIG_LEVEL.NORMAL, FeatureConfigModel.CONFIG_LEVEL.FULL.
     * @return {Boolean} returns true if the feature is enabled AND the level of the feature is enabled.
     */
    isEstimatedCostEnabled: function(configLevel) {
      var featureEnabled = this.isEnabled(configLevel),
          configLevelEnabled = this.get(configLevel + '.estimatedCostEnabled');
      return featureEnabled && configLevelEnabled;
    },

    /**
     * @method isStoredPaymentMethodsEnabled
     * @param [configLevel=FeatureConfigModel.CONFIG_LEVEL.NORMAL] {String} to check whether this level is enabled - one of
     *        FeatureConfigModel.CONFIG_LEVEL.MINIMAL, FeatureConfigModel.CONFIG_LEVEL.NORMAL, FeatureConfigModel.CONFIG_LEVEL.FULL.
     * @return {Boolean} returns true if the feature is enabled AND the level of the feature is enabled.
     */
    isStoredPaymentMethodsEnabled: function(configLevel) {
      configLevel = configLevel || FeatureConfigModel.CONFIG_LEVEL.NORMAL;
      var featureEnabled = this.isEnabled(configLevel),
        configLevelEnabled = this.get(configLevel + '.storedPaymentMethodsEnabled');
      return featureEnabled && configLevelEnabled && !launcherAppInterface.isAtHospital();
    },


    /**
     * Returns boolean indicating an app with stored payments
     * @method storedPmtEnabledOnCurrentApp
     * @returns {boolean}
     * @private
     */
    storedPmtEnabledOnCurrentApp: function() {
      var isAtHospital = launcherAppInterface.isAtHospital();
      var isOnAdminTool = applicationUtils.currentApplication === applicationUtils.APPLICATIONS.ADMIN_TOOL;
      return !isAtHospital && !isOnAdminTool;
    },


    /**
     * @method isCreditCardPaymentEnabled
     * @param [configLevel=FeatureConfigModel.CONFIG_LEVEL.NORMAL] {String} to check whether this level is enabled - one of
     *        FeatureConfigModel.CONFIG_LEVEL.MINIMAL, FeatureConfigModel.CONFIG_LEVEL.NORMAL, FeatureConfigModel.CONFIG_LEVEL.FULL.
     * @return {Boolean} returns true if the feature is enabled AND the level of the feature is enabled.
     */
    isCreditCardPaymentEnabled: function(configLevel) {
      configLevel = configLevel || FeatureConfigModel.CONFIG_LEVEL.NORMAL;
      var featureEnabled = this.isEnabled(configLevel),
        configLevelEnabled = this.get(configLevel + '.creditCardPaymentEnabled');
      return featureEnabled && configLevelEnabled;
    },

    /**
     * @method isAchPaymentEnabled
     * @param [configLevel=FeatureConfigModel.CONFIG_LEVEL.NORMAL] {String} to check whether this level is enabled - one of
     *        FeatureConfigModel.CONFIG_LEVEL.MINIMAL, FeatureConfigModel.CONFIG_LEVEL.NORMAL, FeatureConfigModel.CONFIG_LEVEL.FULL.
     * @return {Boolean} returns true if the feature is enabled AND the level of the feature is enabled.
     */
    isAchPaymentEnabled: function(configLevel) {
      configLevel = configLevel || FeatureConfigModel.CONFIG_LEVEL.NORMAL;
      var featureEnabled = this.isEnabled(configLevel),
        configLevelEnabled = this.get(configLevel + '.achPaymentEnabled');
      return featureEnabled && configLevelEnabled;
    },

    /**
     * @method isPaymentEnabled
     * @param [configLevel=FeatureConfigModel.CONFIG_LEVEL.NORMAL] {String} to check whether this level is enabled - one of
     *        FeatureConfigModel.CONFIG_LEVEL.MINIMAL, FeatureConfigModel.CONFIG_LEVEL.NORMAL, FeatureConfigModel.CONFIG_LEVEL.FULL.
     * @return {Boolean} returns true if the feature is enabled
     */
    isPaymentEnabled: function(configLevel) {
      configLevel = configLevel || FeatureConfigModel.CONFIG_LEVEL.NORMAL;
      return this.isEnabled(configLevel);
    },

    /**
     * @method isAllPortalPaymentsEnabled
     * @param [configLevel=FeatureConfigModel.CONFIG_LEVEL.NORMAL] {String} to check whether this level is enabled - one of
     *        FeatureConfigModel.CONFIG_LEVEL.MINIMAL, FeatureConfigModel.CONFIG_LEVEL.NORMAL, FeatureConfigModel.CONFIG_LEVEL.FULL.
     * @return {Boolean} returns true if the feature is enabled AND the SHARP SPECIFIC portal payments in pre reg only is disabled
     */
    isAllPortalPaymentsEnabled: function(configLevel) {
      configLevel = configLevel || FeatureConfigModel.CONFIG_LEVEL.NORMAL;
      var featureEnabled = this.isEnabled(configLevel);
      var sharpPaymentsInPreRegOnlyEnabled = this.get(configLevel + '.sharpPaymentsInPreRegOnlyEnabled');
      return featureEnabled && !sharpPaymentsInPreRegOnlyEnabled;
    },

    /**
     * Fetches the feature config and resolves to whether the given config level is enabled (true) or disabled (false).
     * @method isPaymentEnabledPromise
     * @param [configLevel=FeatureConfigModel.CONFIG_LEVEL.NORMAL] {String} to check whether this level is enabled - one of
     *        FeatureConfigModel.CONFIG_LEVEL.MINIMAL, FeatureConfigModel.CONFIG_LEVEL.NORMAL, FeatureConfigModel.CONFIG_LEVEL.FULL.
     * @return {jQuery.Deferred.Promise} that resolves to true if the config level has any type of payment enabled, and false otherwise.
     */
    isPaymentEnabledPromise: function(configLevel) {
      var thisFinancialFeatureConfigModel = this;
      return this.loadOnce()
        .then(function() {
          return thisFinancialFeatureConfigModel.isPaymentEnabled(configLevel);
        });
    }
  }))();
}));
